import React from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import FirstOffer from './first-offer/FirstOffer'
import InternalOffers from '../components/InternalOffers'
import Negotation from './negotation/OfferGroups'
import WaitingForOffer from '../components/WaitingForOffer'

const DetailNegotationView = () => {
  const { transaction } = useTransaction()

  return (
    <div className="tennders-brokers-negotiation-info">
      <InternalOffers />
      <FirstOffer />
      <Negotation transaction={transaction} />
      <WaitingForOffer />
    </div>
  )
}

export default DetailNegotationView
